// Short tones for Beta #1 of the loading screen: 'error' for a product that is
// not in the order, 'warning' for a line that needs nothing more. Built with
// an oscillator, so there is no audio file to ship. Where Web Audio is
// missing or blocked it stays silent; the panel still shows the notice.

const TONES = {
  error: [
    { frequency: 220, start: 0, length: 0.15 },
    { frequency: 220, start: 0.22, length: 0.15 },
  ],
  warning: [{ frequency: 660, start: 0, length: 0.12 }],
};

let context = null;

export const playTone = (kind) => {
  try {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return;
    // Created on the first tone, which follows a scan (a key press counts as
    // the user interaction browsers ask for).
    if (!context) context = new AudioContextClass();
    if (context.state === 'suspended') Promise.resolve(context.resume()).catch(() => {});
    const now = context.currentTime;
    (TONES[kind] || []).forEach(({ frequency, start, length }) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = 'square';
      oscillator.frequency.value = frequency;
      gain.gain.value = 0.2;
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(now + start);
      oscillator.stop(now + start + length);
    });
  } catch (err) {
    // No sound.
  }
};
